var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Modal',{attrs:{"visible":_vm.visible,"errorMessage":_vm.errorMessage},on:{"closeDialog":function($event){_vm.visible = false}}}),_c('p',{staticClass:"descriptions"},[(_vm.showDescriptions)?_c('span',[_vm._v(_vm._s(_vm.colDescription))]):_vm._e()]),_c('hot-table',{ref:"hot",attrs:{"data":_vm.hotdata,"settings":_vm.settings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }